import { EServiceType } from '../../redux/reducers/publishTerms/types/serviceType';
import { mapServiceType } from './mapServiceType';

export function mapServiceTypes(serviceTypes: string[]): Array<EServiceType> {
  return serviceTypes.map(mapServiceType).filter(Boolean) as Array<EServiceType>;
}
